export default "__VITE_ASSET__C698KPSw__"